import {FranchiseResource, Franchise, Edition} from "../resource/FranchiseResource";
import * as angular from "angular";

export class FranchiseService {

    public static $inject = ["FranchiseResource"];
    constructor(private FranchiseResource: FranchiseResource) {}

    public getAllFranchises(): angular.IPromise<Franchise[]> {
        return this.FranchiseResource.getAllFranchises();
    }

    public getEditionById(id: string): angular.IPromise<Edition> {
        return this.getAllFranchises().then((franchises) => {

            var foundEdition = null;

            angular.forEach(franchises, (franchise) => {
                angular.forEach(franchise.editions, (edition) => {
                    if (edition.id === id) {
                        foundEdition = edition;
                    }
                });
            });

            return foundEdition;
        });
    }
}
